import styled from "styled-components";

export const Container = styled.div`
  & > button {
    margin-top: 10px;
  }
`;

export const Title = styled.div`
  width: calc(100% - 15px);
`;

export const ImageContent = styled.div`
  text-align: center;
  width: 100%;
  & > iframe {
    width: auto;
    height: calc(100vh - 150px);
  }
`;
